import { observer } from "mobx-react-lite"

import { cn } from "@/domains/library"
import { TokenStore } from "@/domains/tokens"
import { DisplayTokens } from "@/domains/tokens/components/display-tokens"

export interface IDisplayMinimalPool {
  displayType: string
  token0: TokenStore
  token1: TokenStore
  displayName: string
}

export const DisplayMinimalPool = observer(function DisplayMinimalPool({
  pool,
  label = undefined,
  className,
  showLabel = true,
}: {
  pool: IDisplayMinimalPool
  label?: string
  className?: string
  showLabel?: boolean
}) {
  const displayLabel = label ?? pool.displayType

  return (
    <div className={cn("flex flex-col items-center justify-start gap-2 whitespace-nowrap sm:flex-row", className)}>
      <DisplayTokens tokens={[pool.token0, pool.token1]} tokenSize={30} />
      <div className="flex flex-col items-start">
        <div className="text-xs text-t100">{pool.displayName}</div>
        {showLabel ? <div className="text-xs text-t200">{displayLabel}</div> : null}
      </div>
    </div>
  )
})
